import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import Dashboard from '../pages/Dashboard';

const DASHBOARD_ROUTES: IRoute[] = [
	{
		path: 'dashboard',
		element: Dashboard,
		name: 'Dashboard',
		roles: [ROLES.ADMIN],
		private: true,
	},
];

export default DASHBOARD_ROUTES;
